import React, { useEffect, useRef, useState } from "react";

function Formacao() {
  const imageRef = useRef(null);
  const [isImageVisible, setIsImageVisible] = useState(false);

  useEffect(() => {
    const imageElement = imageRef.current;

    if (!imageElement) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsImageVisible(entry.isIntersecting);
      },
      {
        rootMargin: "0px 0px -12% 0px",
        threshold: 0.25,
      },
    );

    observer.observe(imageElement);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="content-section">
      <h2 className="m-3 text-center">Formação</h2>
      <p className=" justificar-texto">
        Psicóloga formada pela Cesuca - Centro Universitário (2020) enquanto
        prounista. Possui especialização em Terapia Sistêmica pelo{" "}
        <a
          href="https://www.cefipoa.com.br/br/terapia-sistemica-individual-conjugal-e-familiar-1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          Centro de Estudos da Família e do Indivíduo{" "}
        </a>
        - CEFI (2023), tendo sido qualificada para o atendimento de indivíduos,
        casais (relações) e famílias.
      </p>

      <p className=" justificar-texto">
        Externship em Terapia Focada nas Emoções para Casais (EFT) com
        certificação internacional do International Centre for Excellence in
        Emotionally Focused Therapy{" "}
        <a
          href="https://iceeft.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          (ICEEFT)
        </a>
        .
      </p>

      <p className=" justificar-texto">
        Também é especialista em
        <a
          href="https://www.ufrgs.br/esdh/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          {" "}
          Educação Social e Direitos Humanos pela Universidade Federal do Rio
          Grande do Sul{" "}
        </a>
        - UFRGS (2024). Fez parte do Programa LBQ Connect -{" "}
        <a
          href="https://outrightinternational.org/lbqconnect"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          OutRight Internacional
        </a>
        , que propõe a qualificação de ativistas lésbicas, bissexuais e queer de
        todo o mundo.
      </p>
      <p className=" justificar-texto">
        Em formação em{" "}
        <a
          href="https://sinteses.org"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          Psicoterapia para Adultos Neurodivergentes
        </a>
        , com previsão de término em setembro/2026 pela Sínteses.
      </p>
      <p className=" justificar-texto">
        Pós-graduanda em Neuropsicologia pela{" "}
        <a
          href="https://comportalmente.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          {" "}
          Comportalmente
        </a>
        .
      </p>
      <p className=" justificar-texto">
        Integrante do{" "}
        <a
          href="https://www.nospsicologia.com/projetos-1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark"
        >
          Grupo de Desenvolvimento Clínico
        </a>{" "}
        da Nós Psicologia (2024/2 - atual).
      </p>

      <div className="col-md-5 p-lg-5 m-5 mx-auto text-center">
        <img
          src="img-mano.jpeg"
          ref={imageRef}
          className={`img-fluid rounded-5 quem-image quem-image-flip ${isImageVisible ? "is-visible" : ""}`}
          alt="Manô Medeiros em foto de perfil profissional"
        />
      </div>
      <div className="section-highlight bg-light">
        <h2 className="m-3 mt-2 text-center">Atuação</h2>
        <p className=" justificar-texto">
          Desde 2018 venho me dedicando ao trabalho com as populações LGBTI+ e
          pessoas vivendo com HIV/AIDS. Iniciei essa trajetória pela inserção no
          G8-Generalizando, um grupo da Faculdade de Direito da Universidade
          Federal do Rio Grande do Sul, na mesma época também iniciei meu
          estágio de conclusão de curso em um Serviço de Atendimento
          Especializado para pessoas vivendo com HIV/AIDS do SUS.
        </p>
        <p className=" justificar-texto">
          Fui organizadora voluntária da Parada Livre de Porto Alegre e da
          Jornada Lésbica Feminista Antirracista, importantes espaços de
          militância local. Representei o Conselho de Psicologia do RS no
          Conselho Estadual LGBT. Estive monitora do curso de aperfeiçoamento em
          Teoria Sistêmica do CEFI, atualmente participo dos Comitês de Ética do
          Hospital Moinhos de Vento e do Instituto de Psicologia, Serviço
          Social, Saúde e Comunicação Humana – UFRGS representando a{" "}
          <a
            className="text-dark"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.somos.org.br"
          >
            ONG Somos
          </a>
          .
        </p>
        <p className=" justificar-texto">
          Fui voluntária na ONG Somos entre janeiro/2020 e janeiro/2025, já
          estive coordenadora do serviço de atendimento e serviço de psicologia
          da instituição, participei de projetos diversos, facilitei grupos de
          convivência, supervisei estágio e fui uma das diretoras da
          instituição. Desde 2020 dedico-me à prática clínica virtual de pessoas
          adultas em terapias individuais ou de relações (casais). Também
          possuindo experiência com formações sobre diversidade sexual e de
          gênero e sexualidade para outres profissionais da psicologia,
          profissionais da saúde e da assistência social e empresas.
        </p>
      </div>
    </div>
  );
}

export default Formacao;
